import { useSelector } from 'react-redux';

export const useFeatureToggle = (featureName) => {
  const features = useSelector((state) => state.featureFlags || {});
  return {
    isLoading: features && features.isLoading,
    isFeatureEnabled: features && features.data && features.data[featureName] === true
  };
};